<template>
    <div class="redirect-wrapper">
        <img
            v-if="!redirectIconPath" 
            class="redirect-icon"
            :src="require('@/assets/icons/redirect.svg')"
            alt="redirect-icon"
        />
        <img 
            v-else
            class="redirect-icon"
            :src="redirectIconPath"
            alt="redirect-icon"
        >
    </div>
    <p 
        v-if="!redirectInstruction"
        class="container__col-md-12 container__col-sm-12 payment__instruction"
    >
        {{ $t("ui.redirect.message")}}
    </p>

    <p
        v-else
        class="container__col-md-12 container__col-sm-12 payment__instruction"
    >
        {{ redirectInstruction }}
    </p>

    <PrimaryButton 
        :content="buttonComment === '' ? $t('ui.redirect.btn') : buttonComment" @click="triggerNext" 
    />
</template>

<script>
import PrimaryButton from "@/components/form/base-button";

export default {
    name: "RedirectView",
    components: {
        PrimaryButton,
    },

    emits: ["next"],

    props: {
        redirectIconPath: {
            type: String,
            required: false,
            default: "",
        },

        redirectInstruction: {
            type: String,
            required: false,
            default: "",
        },

        buttonComment: {
            type: String,
            required: false,
            default: "",
        },
    },
    
    methods: {
        triggerNext() {
            this.$emit("next");
        },
    },

};
</script>